import {Button, styled} from '@mui/material'
import React from 'react'
import style from './day-icon.module.scss'

interface Props {
    day: number,
    color?: string,
    hoverColor?: string,
    onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined,
    disabled?: boolean | true,
}

export default function DayIcon(props: Props) {
    const { day, color, disabled, hoverColor, onClick } = props;

    const DayIconButton = styled(Button)({
        boxShadow: 'none',
        textTransform: 'none',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: '22px',
        textAlign: 'center',
        verticalAlign: 'middle',
        display: 'flex',
        justifyContent: 'center',
        padding: 0,
        ...(color ? { backgroundColor: color } : {}),
        alignItems: 'center',
        width: 32,
        height: 32,
        minWidth: 32,
        minHeight: 32,
        maxWidth: 32,
        maxHeight: 32,
        borderRadius: 8,
        pointerEvents: disabled ? 'none' : 'auto',
        color: 'var(--text-primary)',
        fontFamily: [
            'Roboto',
            'sans-serif'
        ].join(','),
        ':hover': {
            backgroundColor: hoverColor
        }
    })

    return <DayIconButton className={style.dayIcon} onClick={onClick}>
        {day}
    </DayIconButton>
}
